module.exports = __webpack_public_path__ + "static/media/in-number-2.9bde3adf.png";